const state = {
    msgFormasCancelar:'',
    msgErrorFormasSimple: '',
    formas: [],
    formasClasificado : null,
    isConsultando: false,
    formasFormModel: {
        inSelectTipoForma : {model:""},
        inSelectTipoBusqueda: {model:""},//las opciones se jalan del catalogo
        inTxtSerie:         {model:""},
        inNumFolio:         {model:""},
        inRadioButton:      {model:"Vigente", options:["Vigente", "Cancelado"]}, 
        inDate1:            {model:""},
        inDate2:            {model:""},
        inSelectUser:       {model:''},//las opciones se jalan del catalogo
        inSelectConcepto:    {model:''},//las opciones se jalan del catalogo
        inTxtNombre:        {model:""},
        inNum1:             {model:""},
        inNum2:             {model:""}
    },
    totalRecibosMonto:null,
    catalogFormas:null,
    cfdisContribuyenteActual:[],
    isFormCollapse: false,
}

// mutations
const mutations = {
    updateCfdisContribuyenteActual(state, newCfdisContribuyenteActual){
        state.cfdisContribuyenteActual = newCfdisContribuyenteActual;
    },
    updateEstadoCfdiContribuyenteActual(state, info){
        for(var i=0; i<state.cfdisContribuyenteActual.length; i++){
            if(state.cfdisContribuyenteActual[i].uuid == info.uuid){
                //Solo se actualiza si pasa a cancelado
                if(info.estado.includes('CANCELADO')){
                    state.cfdisContribuyenteActual[i].estado = 'CANCELADO';
                }                
            }
        }
    },
    updateCatalogFormas(state, newCatalogFormas){
        state.catalogFormas = newCatalogFormas;
        //state.catalogFormas.tiposFormas.push("RECIBOS");
    },
    updateTotalRecibosMonto(state, newMonto){
        state.totalRecibosMonto = newMonto;
    },
    updateMsgFormasCancelar (state, newMsgFormasCancelar) {
        state.msgFormasCancelar = newMsgFormasCancelar;
    },
    updateMsgErrorFormasSimple (state, newMsgErrorFormasSimple) {
        state.msgErrorFormasSimple = newMsgErrorFormasSimple;
    },
    updateFormasFormModel (state, newFormasFormModel){
        state.formasFormModel = newFormasFormModel;
      },
    updateFormas (state, newFormas) {
        state.formas = newFormas;
    },
    updateFormasClasificado(state, newFormas) {
        state.formasClasificado = newFormas;
    },
    updateIsConsultando (state, newIsConsultando) {
        state.isConsultando = newIsConsultando;
    },
    configCurrentDates(){
        var fechaActual = new Date().toISOString().substring(0,10);
        state.formasFormModel.inDate1.model = fechaActual;
        state.formasFormModel.inDate2.model = fechaActual;
    },
    updateIsFormCollapse(state, newIs){
        state.isFormCollapse= newIs;
    }
}

export default {
    state,
    mutations
}